module.exports = __webpack_public_path__ + "img/passageBill.f7879678.svg";